import React from "react";
import {observer} from "mobx-react";
import {Alert} from "@ann/web-components";
import {useToast} from "../../hook";
import {ToastViewPortWrapper} from "./toast-viewport.styled";

const ToastVariant = {
    success: "success",
    info: "info",
    warning: "warning",
    error: "error",
}

export const ToastViewport = observer(() => {
    const { position, items, close } = useToast();
    return (
        <ToastViewPortWrapper $position={position}>
            {items.map(item => {
                const severity = ToastVariant[item.variant] || "info";
                
                return (
                    <Alert
                        key={item.id}
                        title={item.title || ""}
                        description={item.message}
                        severity={severity}
                        maxWidth={item.maxWidth || "692px"}
                        closable={item.canClose}
                        autoClose={item.duration > 0}
                        autoCloseDelay={item.duration}
                        onClose={() => close(item.id)}
                        action={item.action}
                        onAction={item.onAction}
                    />
                );
            })}
        </ToastViewPortWrapper>
    );
});